export default __webpack_public_path__ + "static/media/logo.d93f0beb.png";